<div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Header -->
            <div class="modal-header User-Form">
                <h5 class="modal-title text-black">Verification Password</h5>
                <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
            </div>

            <!-- Body -->
            <div class="modal-body">
                <!-- Password -->
                <form>
                    <div class="col">
                        <app-input [customClass]="'text-black'" [inputName]="'password'" [inputType]="'password'"
                            [inputId]="'passwordId'" [inputValue]="userForm.password" [inputLabel]="'Password'"
                            [inputPlaceholder]="'Enter password'" (inputValueEmit)="userForm.password = $event"
                            [isRequired]="true" [isEyeIconShow]="true">
                        </app-input>
                    </div>
                </form>
            </div>

            <!-- Footer -->
            <div class="modal-footer">
                <app-button class="btns btnRadius" [customClass]="'danger'" [buttonLabel]="'Close'"
                    (click)="activeModal.dismiss()">
                </app-button>
                <app-button class="btns" [customClass]="'primary'" [buttonLabel]="'Save'" (click)="save()">
                </app-button>
            </div>

        </div>
    </div>
</div>